import { Button, Checkbox } from 'semantic-ui-react';
import { dayInTZ } from 'src/components/helpers';
import { formatCompletedAttendance } from 'src/components/eventsLogin/AttendanceModal';
import { crecerSteps, seminaryEvent } from 'src/containers/crecer/crecerShared';
import {
  PageWrapper,
  StepCard,
  StepTitle,
  StepSubtitle,
  AttendanceLegend,
  DateListSection,
} from './styles';

export default function DatesStep({
  inputs,
  datesForEvent,
  stepsMadeForEvent,
  selectedAttendanceCodes,
  selectedCodesList,
  submitting,
  hasAttendance,
  toggleDateSelection,
  onMarkAttendance,
  onChangeCourse,
}) {
  const typeLabel =
    inputs.type === 'crecer'
      ? crecerSteps.find((o) => o.value === inputs.step)?.text ?? inputs.step
      : seminaryEvent.find((o) => o.value === inputs.seminary)?.text ?? inputs.seminary;

  return (
    <PageWrapper>
      <StepCard>
        <Button secondary size="tiny" onClick={onChangeCourse}>
          Cambiar curso
        </Button>
        <StepTitle>Asistencia: {typeLabel}</StepTitle>
        <StepSubtitle>
          Las fechas con ✓ ya tienen asistencia. Marca las que quieras registrar como asistidas.
        </StepSubtitle>
        <AttendanceLegend>
          <span className="legend-item">
            <span className="status-indicator status-date-green">✓</span>
            Completado
          </span>
          <span className="legend-item">
            <span className="status-indicator status-date-orange">✓</span>
            Marcado previamente por usted
          </span>
          <span className="legend-item">
            <span className="status-indicator status-false">✕</span>
            Sin completar
          </span>
        </AttendanceLegend>
        <DateListSection>
          {datesForEvent.length === 0 ? (
            <p style={{ color: '#5f5f5f' }}>No hay fechas cargadas para este curso.</p>
          ) : (
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {datesForEvent.map((date) => {
                const attended = hasAttendance(date);
                const content = stepsMadeForEvent?.[0];
                const attendanceInfo = content?.[date.attendanceCode];
                const isJan2000 =
                  attendanceInfo && dayInTZ(attendanceInfo, 'YYYY-MM-DD') === '2000-01-01';
                const statusClass = attended
                  ? isJan2000
                    ? 'status-date-orange'
                    : 'status-date-green'
                  : 'status-false';
                return (
                  <li
                    key={date.id}
                    className={`step-item ${attended ? 'has-attendance' : 'no-attendance'}`}
                  >
                    <span style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                      {date.attendanceName}
                      <span
                        className={`status-indicator ${statusClass}`}
                        title={
                          attended
                            ? formatCompletedAttendance(attendanceInfo, 'DD [de] MMMM [de] YYYY')
                            : 'Sin asistencia'
                        }
                      >
                        {attended ? '✓' : '✕'}
                      </span>
                    </span>
                    {!attended && (
                      <Checkbox
                        checked={!!selectedAttendanceCodes[date.attendanceCode]}
                        onChange={() => toggleDateSelection(date.attendanceCode)}
                        label="Marcar asistencia"
                      />
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </DateListSection>
        <Button
          primary
          disabled={submitting || selectedCodesList.length === 0}
          loading={submitting}
          onClick={onMarkAttendance}
        >
          {submitting ? 'Registrando...' : `Registrar asistencia (${selectedCodesList.length})`}
        </Button>
      </StepCard>
    </PageWrapper>
  );
}
